<template>
  <div>广告素材</div>
</template>

<script>
export default {
  name: "AdMaterial",
};
</script>